import React from 'react'
import store from '../../redux/store'
import SettingsSelect from '../../shared/components/SettingsSelect/SettingsSelect'

interface ActivityFunctionFieldProps {
    value: string
    onChange: (val: string) => void
    disabled?: boolean
    existingValue?: string
    error?: boolean
    helperText?: string
    required?: boolean
}

const ActivityFunctionField: React.FC<ActivityFunctionFieldProps> = ({
    value,
    onChange,
    disabled,
    existingValue,
    error,
    helperText,
    required,
}) => {
    const rawOptions: string[] = store.getState()?.settings?.activityFunctions || []
    const options = rawOptions.map((s) => ({ value: s, label: s }))

    return (
        <SettingsSelect
            value={value}
            onChange={onChange}
            options={options}
            placeholder="Select Function"
            disabled={disabled}
            existingValue={existingValue}
            error={error}
            helperText={helperText}
            required={required}
        />
    )
}

export default ActivityFunctionField
